class GoogleAnalytics {
  constructor() {
    this.isEnabled = typeof window !== 'undefined' && window.gtag && window.GA_MEASUREMENT_ID;
    this.measurementId = typeof window !== 'undefined' ? window.GA_MEASUREMENT_ID : null;
  }

  pageView(page_path) {
    if (this.isEnabled && this.measurementId) {
      window.gtag('config', this.measurementId, {
        page_path: page_path,
      });
    }
  }

  event(action, parameters = {}) {
    if (this.isEnabled) {
      window.gtag('event', action, parameters);
    }
  }

  trackPageView(pageName) {
    this.pageView(`/${pageName}`);
  }

  trackPDFConversion(fileType, fileSize) {
    this.event('pdf_conversion', {
      event_category: 'conversion',
      event_label: fileType,
      value: Math.round(fileSize / 1024), // Size in KB
      custom_parameters: {
        file_type: fileType,
        file_size_kb: Math.round(fileSize / 1024)
      }
    });
  }

  trackFileUpload(fileType, fileSize) {
    this.event('file_upload', {
      event_category: 'engagement',
      event_label: fileType,
      value: Math.round(fileSize / 1024),
      custom_parameters: {
        file_type: fileType,
        file_size_kb: Math.round(fileSize / 1024)
      }
    });
  }

  trackDownload(fileType) {
    this.event('file_download', {
      event_category: 'conversion',
      event_label: fileType,
      custom_parameters: {
        file_type: fileType
      }
    });
  }

  trackError(errorType, errorMessage) {
    this.event('error', {
      event_category: 'error',
      event_label: errorType,
      custom_parameters: {
        error_type: errorType,
        error_message: errorMessage
      }
    });
  }

  trackButtonClick(buttonName, location) {
    this.event('button_click', {
      event_category: 'engagement',
      event_label: buttonName,
      custom_parameters: {
        button_name: buttonName,
        location: location
      }
    });
  }

  trackEvent(eventName, eventLabel, customParameters = {}) {
    this.event(eventName, {
      event_category: 'pdf_tools',
      event_label: eventLabel,
      custom_parameters: customParameters
    });
  }
}

const analytics = new GoogleAnalytics();
export default analytics;